"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateReceipt = void 0;
const helpers_1 = require("../../helpers");
const orders_1 = require("../orders");
const roundToTwo_1 = require("../roundToTwo");
const uuid_1 = require("uuid");
const generateReceipt = async (supabase, order_line_ids, order, credit_card_fee, total_paid, merchant_fee, invoice_id) => {
    if (!order.order_lines)
        return;
    try {
        // GENERATE RECEIPT CODE HERE FOR NOW
        const total_paid_by_client = total_paid; // this is the transaction amount 5040
        const pre_fee_amount = total_paid_by_client / (1 + credit_card_fee); // this is the amount before the credit card fees were added
        const total_fee_value = total_paid_by_client - pre_fee_amount; // This is the fee value (e.g. 4%)
        const transaction_objs = [];
        const transaction_items = [];
        // Update all order line IDs related to this payment to the percentage set.
        for (let i = 0; i < order_line_ids.length; i++) {
            const order_line_id = order_line_ids[i];
            // get the order line from the order
            const order_line = order.order_lines?.find((ol) => ol.id === order_line_id.id);
            if (!order_line?.versions)
                return;
            // get its latest version
            const latest_version = await (0, orders_1.getLatestOrderLineVersion)(order_line?.versions);
            const line_accountancy = (0, orders_1.getOrderLineAccountancyDetails)(order_line, order_line_id.amount_paid, i);
            if (!latest_version)
                return;
            const supplier_vat = latest_version.config?.supplier?.offerings?.golf?.offerings?.green_fees
                ?.vat || 0; // this is e.g. 0.07
            const total_fee_value_vat = total_fee_value - total_fee_value / (1 + supplier_vat); // this is the OUTPUT VAT on the Credit card charge by Golfsavers (e.g. 4%)
            const merchant_fee_vat = merchant_fee - merchant_fee / (1 + supplier_vat); // this is the INPUT VAT on the amount we were charged by the payment provider (e.g. 2.4%)
            const total_line_output_vat = line_accountancy.reduce((a, b) => a + b.output_vat, 0);
            const total_output_vat = total_line_output_vat + total_fee_value_vat;
            const total_output_vat_minus_input_vat = total_output_vat - merchant_fee_vat;
            latest_version.amount_paid =
                order_line_id.amount_paid + latest_version?.amount_paid;
            const line_accountancy_obj = {
                sales_golfsavers_debit: total_output_vat_minus_input_vat,
                vat_debit: merchant_fee_vat,
                vat_credit: total_output_vat,
            };
            transaction_objs.push(line_accountancy_obj);
            // update the version with the payment response
            await (0, orders_1.updateOrderLineVersion)(supabase, latest_version);
        }
        const currency = (0, orders_1.getOrderLineCurrency)(order?.order_lines[0]) || "";
        console.log("##############################");
        const transaction_id = (0, uuid_1.v4)();
        console.log("Payment Provider Bank Account (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(total_paid_by_client - merchant_fee));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(total_paid_by_client - merchant_fee),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: "bbdc0967-db40-417e-ae94-a74668770892",
            order_line_id: null,
        });
        console.log("Debtors - Clients (THB) | Credit |", (0, roundToTwo_1.roundToTwo)(pre_fee_amount));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(pre_fee_amount),
            direction: -1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getClientDebtorsAccountByCurrency)(currency),
            order_line_id: null,
        });
        console.log("Thai VAT (THB) | Credit |", (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.vat_credit, 0)));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.vat_credit, 0)),
            direction: -1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getVATAccountByCurrency)(currency),
            order_line_id: null,
        });
        console.log("Thai VAT (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.vat_debit, 0)));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.vat_debit, 0)),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getVATAccountByCurrency)(currency),
            order_line_id: null,
        });
        console.log("Sales - Golfsavers (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.sales_golfsavers_debit, 0)));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.sales_golfsavers_debit, 0)),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getRevenueAccountByCurrencySource)(currency, order.source),
            order_line_id: null,
        });
        console.log("Pending Sales - Golfsvers (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(pre_fee_amount));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(pre_fee_amount),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getPendingSalesAccountByCurrencySource)(currency, order.source),
            order_line_id: null,
        });
        console.log("Sales - Golfsvers (THB) | Credit |", (0, roundToTwo_1.roundToTwo)(pre_fee_amount));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(pre_fee_amount),
            direction: -1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getRevenueAccountByCurrencySource)(currency, order.source),
            order_line_id: null,
        });
        console.log("Sales -Credit Card Fees (THB) | Credit |", (0, roundToTwo_1.roundToTwo)(total_fee_value));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(total_fee_value),
            direction: -1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getSalesCreditCardAccountByCurrency)(currency),
            order_line_id: null,
        });
        console.log("Merchant Fees (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(merchant_fee));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(merchant_fee),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getMerchantFeeAccountByCurrency)(currency),
            order_line_id: null,
        });
        console.log("Transaction (RECEIPT) Value|", (0, roundToTwo_1.roundToTwo)(total_paid_by_client));
        const transaction = {
            id: transaction_id,
            type: "RECEIPT",
            currency: currency,
            amount: total_paid_by_client,
            note: `Receipt for ${order.reference}`,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            related_transactions: [invoice_id],
        };
        const transaction_orders = [];
        transaction_orders.push({
            transaction_id: transaction_id,
            order_id: order.id,
        });
        // create the transaction
        await supabase.from("transactions").insert([transaction]);
        await supabase.from("transaction_orders").insert(transaction_orders);
        await supabase.from("transaction_items").insert(transaction_items).select();
        console.log("##############################");
    }
    catch (e) {
        console.log("ERROR", e);
    }
};
exports.generateReceipt = generateReceipt;
